<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">Rolling Management</a>
      <div class="collapse navbar-collapse">
          <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'setting-rolling', 'form']">&#43; Add Rolling</a>
      </div>
    </div>
  </nav>
  <hr/>
  <div class="row">
    <div class="col-12">
      <app-table #table></app-table>
    </div>
  </div>